/**
 * Created by youzipi on 2018-01-13
 *
 * 订单结算
 */

import * as types from '../mutation-types'
import couponApi from "../../api/coupon"
import CouponCode from '../../domain/coupon'
import Checkout from '../../domain/checkout'
import * as Vue from "vue";
import * as z from "../../utils";

const state = {
  savedItems: [],
  /**
   * @type {[Checkout]}
   */
  checkout: [],
  /**
   * @type {[CouponCode]}
   */
  coupons: [],
  order: {},
  toPay: null,
  // review: null,
  comment: '',
}

const mutations = {
  [types.ADD_TO_ORDER](state) {
    // state.info.total += 1
    // window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },
  [types.REMOVE_ORDER](state) {
    // state.info.total -= 1
    // window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },
  [types.CHECKOUT](state, carts) {
    state.checkout = carts.map(cart => Object.assign(new Checkout(), cart))
    window.localStorage.setItem('checkout', JSON.stringify(state.checkout))
  },
  [types.UPDATE_CHECK_ITEM](state, checkItem) {
    // todo
    // console.log('UPDATE_CHECK_ITEM')
  },
  [types.COMMENT](state, comment) {
    state.comment = comment
  },
  [types.ORDER](state, order) {
    state.order = order
  },

  // [types.REVIEW](state, product) {
  //   state.review = product
  // },
  [types.UPDATE_COUPONS](state, coupons) {
    state.coupons = coupons
    // console.log('============coupons')
    // console.log(coupons)
  },
  /**
   *
   * @param state
   * @param cartId
   * @param codeIds []
   */
  [types.TRIGGER_COUPON_ITEM](state, {cartId, codeIds}) {
    // console.log(codeIds)
    // console.log(`TRIGGER_COUPON_ITEM,cartId=${cartId},codeIds=${codeIds}`)
    codeIds.forEach(codeId => {
        let index = state.coupons.findIndex(c => c.id === codeId)
        let isSelected = !state.coupons[index].isSelected
        // console.log(`TRIGGER_COUPON_ITEM:loop: codeId=${codeId},isSelected=${isSelected}`)
        Vue.set(state.coupons[index], 'isSelected', isSelected)

        if (isSelected) {
          // 部分客户同一个coupon_id 可能拥有多张满减券
          if (state.coupons[index].coupon.type === 0) {
            let idx = state.coupons.findIndex(c => c.cartId === cartId && c.coupon.type === 0)
            if (idx !== -1) {
              Vue.set(state.coupons[idx], 'cartId', null)
              Vue.set(state.coupons[idx], 'isSelected', false)
            }
          }

          let couponId = state.coupons[index].coupon.id
          let len = state.coupons.length
          for (let idx = 0; idx < len; idx++) {
            let code = state.coupons[idx]
            if (code.cartId === cartId && code.coupon.id !== couponId && code.coupon.type !== 4) {
              Vue.set(state.coupons[idx], 'cartId', null)
              Vue.set(state.coupons[idx], 'isSelected', false)
            }
          }
          Vue.set(state.coupons[index], 'cartId', cartId)
        }
        else {
          Vue.set(state.coupons[index], 'cartId', null)
        }
      }
    )
    // console.log('===========checkout')
    // console.log(state.checkout)
  },
  [types.UPDATE_CHECK_COUPONS](state, {cartId}) {
    // console.log(`UPDATE_CHECK_COUPONS,cartId=${cartId}`)

    let index = state.checkout.findIndex(c => c.id === cartId)
    let couponCodes = state.coupons.filter(code => code.cartId === cartId)
    let couponCodeIds = couponCodes.map(code => code.id)

    Vue.set(state.checkout[index], 'couponCodes', couponCodes)
    Vue.set(state.checkout[index], 'couponCodeIds', couponCodeIds)
  },

}
const actions = {
  async fetchCoupons(context) {
    let {commit, state, rootState} = context
    let coupons = []
    // console.log('fetchCoupons')
    try {
      // 查询 所有 该用户的 在活动期内的 可用的 优惠券
      let dataCoupons = await couponApi.acitveList()
      coupons = dataCoupons.map(code => {
        return Object.assign(new CouponCode(), code)
      }).sort((code1, code2) => {
        return code1.compare(code2)
      })
    }
    catch (err) {
      console.log(err)
    }
    commit(types.UPDATE_COUPONS, coupons)
  },
  /**
   * 匹配 cartItem 和 couponCode
   * @param context
   */
  bindCoupons(context) {
    // console.log('bindCoupons')
    let {commit, state, dispatch} = context
    let {coupons} = state

    let today = new Date()

    let _checkout = state.checkout.map(c => {
      // 适用 该产品的 优惠券
      // 未过期的 且 cart.serialId等于code.serialId 且 有code.serialId === ''的活动减免券
      let matched = coupons
        .filter(code => code.matchCart(c))
        .filter(code => code.endTime >= today)
        .filter(code => code.matchActivityCart(c))
        .map(code => code.id)
      // console.log(matched)
      return {
        ...c,
        // coupons: matched,
        matchedCouponCodeIds: matched,
      }
    })
    commit(types.CHECKOUT, _checkout)
    dispatch('fillCoupons')
  },

  /**
   * 自动勾选 couponCode
   * @param context
   */
  fillCoupons(context) {

    // console.log('fillCoupons')
    let {commit, dispatch, state} = context
    let {checkout, coupons} = state


// 分配优惠券 自动勾选所有可用优惠券
    for (let c of checkout) {
      let cartId = c.id

      /**
       * 该 cart 可用的 couponCodeId 列表
       * @type {*|Array}
       */
      let matchedCouponCodeIds = c.matchedCouponCodeIds || []

      let unSelectedCodes = coupons
        .filter(code => !code.isSelected)
        .filter(code => code.matchFullPrice(c))
        .filter(code => matchedCouponCodeIds.includes(code.id))

      if (z.isDev) {
        // debugger
      }

      // console.log('======unSelectedCode')
      // console.log(unSelectedCodes)

      let offPriceCode = unSelectedCodes.find(code => code.isOffPrice)
      if (offPriceCode) {
        commit(types.TRIGGER_COUPON_ITEM, {
          cartId: cartId,
          codeIds: [offPriceCode.id],
        })
      }

      let giftPriceCodes = unSelectedCodes.filter(code => code.isGiftPrice)
      let giftPriceCodeIds = giftPriceCodes.map(code => code.id)
      commit(types.TRIGGER_COUPON_ITEM, {
        cartId: cartId,
        codeIds: giftPriceCodeIds,
      })

      commit(types.UPDATE_CHECK_COUPONS, {
        cartId: cartId,
      })

    }
  },
  selectCoupon(context, {cartId, codeIds}) {
    let {commit, dispatch, state} = context
    commit(types.TRIGGER_COUPON_ITEM, {
      cartId: cartId,
      codeIds: codeIds,
    })
    commit(types.UPDATE_CHECK_COUPONS, {
      cartId: cartId,
    })
  }

}


export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/module/order_pay.js